export default function applyPercentageDiscount(salesAmount, percentage) {
  const p = parseFloat(percentage) / 100;
  const s = parseFloat(salesAmount) / 100;
  const da = (p / 100) * s;

  const newPrice = s - da;

  return Math.round((newPrice + Number.EPSILON) * 100);
}
